module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAABKCAMAAAC8X5WZAAAANlBMVEUAAAD////////////////////////////////////////////////////////////////////xY8b8AAAAEXRSTlMAh3gY2tKBPzcP9erjzI1IKrl4+lMAAABWSURBVDjL7dRLDoAwCEVRKNa2/tn/Zk0NiQ8HOjKxiXd25vColoOVDga1+Ja9YyzISQg4bgQcMiEXcuRmqbWfDfMjh/QGOzlpRmoUR53L9dmflyGxte6qBCDZA02ZxQAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/pages/page-one/img/q-left.png
// module id = dbN2
// module chunks = 0